import { Injectable } from '@angular/core';
import { FacilityService } from './facility.service';
import { CheckoutComponent } from 'src/app/components/popups/my-drop/checkout/checkout.component';
import { FFCheckoutComponent } from 'src/app/components/popups/my-drop/ff-checkout/ff-checkout.component';

@Injectable({ providedIn: 'root' })
export class CheckoutComponentFactoryService {
  constructor(private facilityService: FacilityService) {}

  getCheckoutComponent(): any {
    return FFCheckoutComponent;
  }
}